import styled from 'styled-components'
import { CardWrapper } from './Base'

export const DeleteWrapper = styled.div`
  text-align: center;
  position: absolute;
  top: 0px;
  right: 0px;
`

export const DeleteIcon = styled.span`
  position: relative;
  display: inline-block;
  width: 16px;
  height: 16px;
  opacity: 0;
  overflow: hidden;
  border-radius: 50%;
  padding: 4px;
  background: #ccc;
  margin:5px;

  &:before,
  &:after {
    content: '';
    position: absolute;
    height: 2px;
    width: 60%;
    top: 45%;
    left: 20%;
    background: #e5e5e5;
    border-radius: 5px;
  }

  &:before {
    -webkit-transform: rotate(45deg);
    -moz-transform: rotate(45deg);
    -o-transform: rotate(45deg);
    transform: rotate(45deg);
  }

  &:after {
    -webkit-transform: rotate(-45deg);
    -moz-transform: rotate(-45deg);
    -o-transform: rotate(-45deg);
    transform: rotate(-45deg);
  }

  ${CardWrapper}:hover & {
    opacity: 1;
  }

  &:hover {-webkit-transition: all 0.5s ease;
  -moz-transition: all 0.5s ease;
  -o-transition: all 0.5s ease;
  -ms-transition: all 0.5s ease;
  transition: all 0.5s ease;
    background: #eb3939;
    color: #ffffff;
    cursor:pointer;
    opacity: 1;
  }

  
`

export const ExpandCollapseBase = styled.span`
  width: 36px;
  margin: 0 auto;
  
  position: relative;
  cursor: pointer;

`

export const CollapseBtn = styled(ExpandCollapseBase)`
  &:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    border-bottom: 7px solid #444;
    border-left: 7px solid transparent;
    border-right: 7px solid transparent;
    border-radius: 6px;
  }
  &:after {
    content: '';
    position: absolute;
    left: 4px;
    top: 4px;
    border-bottom: 3px solid #e3e3e3;
    border-left: 3px solid transparent;
    border-right: 3px solid transparent;
  }
`

export const ExpandBtn = styled(ExpandCollapseBase)`
  &:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    border-top: 7px solid #444;
    border-left: 7px solid transparent;
    border-right: 7px solid transparent;
    border-radius: 6px;
  }
  &:after {
    content: '';
    position: absolute;
    left: 4px;
    top: 0px;
    border-top: 3px solid #e3e3e3;
    border-left: 3px solid transparent;
    border-right: 3px solid transparent;
  }
`

export const AddButton = styled.button`
  background: #16ab39;;
  color: #fff;
  transition: background 0.3s ease;
  min-height: 32px;
  padding: 4px 16px;
  vertical-align: top;
  margin-top: 0;
  margin-right: 8px;
  font-weight: normal;
  border-radius: 3px;
  
  cursor: pointer;
  margin-bottom: 0;
  border:none;
  min-width:72px
`

export const CancelButton = styled.button`
  background: #B9CAD3;
  color: #fff;
  transition: background 0.3s ease;
  min-height: 32px;
  padding: 4px 16px;
  vertical-align: top;
  margin-top: 0;
  font-weight: normal;
  border-radius: 3px;
  
  cursor: pointer;
  margin-bottom: 0;
  border:none;
  min-width:72px
`
